import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CoverpathUtils } from '../../../../../coverpath-common/js/static/CoverpathUtils';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { WindowService } from '../../../../../common/angular-shared/services/window/window.service';
import { GenesysContext, GenesysParticipantData } from '../../../../../common/js/types/CommonTypes';

@Component({
  moduleId: module.id,
  selector: 'faq',
  templateUrl: './faq.component.html',
})
export class FaqComponent implements OnInit {
  controller;
  singularAdvisorDescriptiveNoun: string;
  advisorDescriptiveNoun: string;
  genesysParticipantData: GenesysParticipantData;
  enableGenesysCobrowse: boolean;
  allowReapply: boolean;

  constructor(
    private amorphicService: AmorphicService,
    private windowService: WindowService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.controller = amorphicService.controller;
  }

  ngOnInit() {
    // HL-17855 'financial professional'
    this.advisorDescriptiveNoun = CoverpathUtils.getAdvisorDescriptiveNoun();
    this.singularAdvisorDescriptiveNoun = `a ${CoverpathUtils.getAdvisorDescriptiveNoun()}`;
    const customer = this.controller.customer;
    this.genesysParticipantData = {
      'WP-Authenticated': customer.email ? true : false,
      'WP-Context': GenesysContext.COVERPATH_CLIENT,
      'WP-First-Name': customer.firstName,
      'WP-Last-Name': customer.lastName,
      'WP-Email': customer.email,
      'WP-Is-1851': false,
    };
    this.allowReapply = !this.controller.nbDecommissionPost30Days;
  }

  scrollToElement(id: string) {
    CoverpathUtils.scrollToElement(id);
  }
}
